// extracted by mini-css-extract-plugin
module.exports = {"tab":"Tab_tab__Z2EY2","active":"Tab_active__2pQdy","disabled":"Tab_disabled__x0Cy7"};